import { render, staticRenderFns } from "./BrandCouriers.vue?vue&type=template&id=700ea6f9&"
import script from "./BrandCouriers.vue?vue&type=script&lang=js&"
export * from "./BrandCouriers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports